import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

interface HelpButtonProps {
  section?: string;
  className?: string;
}

const HelpButton: React.FC<HelpButtonProps> = ({ section = 'general', className = '' }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleClick = () => {
    history.push(`/ayuda/${section}`);
  };

  return (
    <button
      className={`help-button${className ? ` ${className}` : ''}`}
      onClick={handleClick}
      aria-label={t('common.help')}
    >
      ?
    </button>
  );
};

export default HelpButton;
